import { render, staticRenderFns } from "./nav-layout.vue?vue&type=template&id=0390628c&scoped=true"
import script from "./nav-layout.vue?vue&type=script&lang=js"
export * from "./nav-layout.vue?vue&type=script&lang=js"
import style0 from "./nav-layout.vue?vue&type=style&index=0&id=0390628c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0390628c",
  null
  
)

export default component.exports